'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePowerInput = function HardwarePowerInput(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
  );
};
HardwarePowerInput = (0, _pure2.default)(HardwarePowerInput);
HardwarePowerInput.displayName = 'HardwarePowerInput';

exports.default = HardwarePowerInput;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/hardware/power-input.js
 ** module id = 1526
 ** module chunks = 0
 **/